(function() {
  const osk = document.getElementById('hebrew-osk');
  let Keyboard, keyboard, activeInput = null;
  let lang = 'he';
  let layer = 'default';

  function isTarget(el) {
    return el
      && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA')
      && (el.type === 'text' || el.tagName === 'TEXTAREA')
      && el.name
      && el.name.startsWith('properties[')
      && !el.dataset.oskEnhanced
      && !el.readOnly
      && !el.disabled;
  }

  function enhanceInput(el) {
    const wrap = document.createElement('div');
    wrap.className = 'osk-wrap';
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'osk-toggle';
    btn.setAttribute('aria-label', 'Hebrew keyboard');
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M8 14h8"/></svg>';
    wrap.appendChild(btn);

    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (!window.SimpleKeyboard) {
        console.error('simple-keyboard library not found. Check that index.min.js is included before hebrew-osk.js');
        return;
      }

      activeInput = el;

      if (!keyboard) initKeyboard();

      lang = 'he';
      layer = 'default';
      setLayout(layer);

      el.setAttribute('dir', 'rtl');
      osk.hidden = false;
      el.focus();
    });

    el.addEventListener('blur', () => {
      setTimeout(() => {
        if (!osk.matches(':hover')) {
          osk.hidden = true;
          activeInput = null;
        }
      }, 150);
    });

    el.dataset.oskEnhanced = '1';
  }

  function enhanceExisting() {
    document
      .querySelectorAll('input[name^="properties["], textarea[name^="properties["]')
      .forEach(el => { if (isTarget(el)) enhanceInput(el); });
  }

  const mo = new MutationObserver(muts => {
    muts.forEach(m => {
      m.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;
        if (isTarget(node)) enhanceInput(node);
        node
          .querySelectorAll?.('input[name^="properties["], textarea[name^="properties["]')
          .forEach(el => { if (isTarget(el)) enhanceInput(el); });
      });
    });
  });

  function initObserver() {
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  const layouts = {
    he: {
      default: [
        'ק ר א ט ו ן ם פ {bksp}',
        '{tab} ש ד ג כ ע י ח ל ך ף',
        '{caps} ז ס ב ה נ מ צ ת ץ {enter}',
        '{lang} {space} {123}'
      ],
      shift: [
        'ק ר א ט ו ן ם פ {bksp}',
        '{tab} ש ד ג כ ע י ח ל ך ף',
        '{caps} ז ס ב ה נ מ צ ת ץ {enter}',
        '{lang} {space} {123}'
      ],
      numbers: [
        '1 2 3 4 5 6 7 8 9 0 {bksp}',
        '- / : ; ( ) ₪ " \' ,',
        '{shift} . ? ! @ # $ % ^ & * {enter}',
        '{lang} {space} {abc}'
      ]
    },
    en: {
      default: [
        'q w e r t y u i o p {bksp}',
        '{tab} a s d f g h j k l',
        '{caps} z x c v b n m {enter}',
        '{lang} {space} {123}'
      ],
      shift: [
        'Q W E R T Y U I O P {bksp}',
        '{tab} A S D F G H J K L',
        '{caps} Z X C V B N M {enter}',
        '{lang} {space} {123}'
      ],
      numbers: [
        '1 2 3 4 5 6 7 8 9 0 {bksp}',
        '- / : ; ( ) $ " \' ,',
        '{shift} . ? ! @ # % ^ & * {enter}',
        '{lang} {space} {abc}'
      ]
    }
  };

  const display = {
    '{bksp}': '⌫',
    '{enter}': '⏎',
    '{tab}': '⇥',
    '{caps}': '⇪',
    '{space}': '␣',
    '{lang}': 'HE/EN',
    '{123}': '123',
    '{abc}': 'ABC',
    '{shift}': '⇧'
  };

  function currentLayout() {
    if (layer === 'numbers') return layouts[lang].numbers;
    return layouts[lang][layer] || layouts[lang].default;
  }

  function applyRTL() {
    const kbEl = osk.querySelector('.simple-keyboard');
    if (!kbEl) return;
    if (lang === 'he' && layer !== 'numbers') kbEl.classList.add('rtl');
    else kbEl.classList.remove('rtl');

    if (activeInput) {
      if (lang === 'he' && layer !== 'numbers') activeInput.setAttribute('dir', 'rtl');
      else activeInput.removeAttribute('dir');
    }
  }

  function initKeyboard() {
    if (keyboard) return;

    if (!window.SimpleKeyboard) {
      console.error('simple-keyboard library not found when trying to init.');
      return;
    }

    Keyboard = window.SimpleKeyboard.default || window.SimpleKeyboard;

    keyboard = new Keyboard('#hebrew-osk', {
      layout: { default: currentLayout() },
      display,
      onKeyPress,
      rtl: (lang === 'he' && layer !== 'numbers')
    });

    applyRTL();

    osk.addEventListener('mousedown', (e) => e.preventDefault());
  }

  function setLayout(newLayer) {
    layer = newLayer;
    if (!keyboard) return;
    keyboard.setOptions({
      layout: { default: currentLayout() },
      display,
      rtl: (lang === 'he' && layer !== 'numbers')
    });
    applyRTL();
  }

  function toggleLang() {
    lang = lang === 'he' ? 'en' : 'he';
    if (layer !== 'numbers') layer = 'default';
    setLayout(layer);
  }

  function insertAtCaret(text) {
    if (!activeInput) return;
    const start = activeInput.selectionStart ?? activeInput.value.length;
    const end = activeInput.selectionEnd ?? activeInput.value.length;
    activeInput.value =
      activeInput.value.slice(0, start) + text + activeInput.value.slice(end);
    const pos = start + text.length;
    activeInput.setSelectionRange(pos, pos);
    activeInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function backspace() {
    if (!activeInput) return;
    const start = activeInput.selectionStart ?? activeInput.value.length;
    const end = activeInput.selectionEnd ?? activeInput.value.length;
    if (start === end && start > 0) {
      activeInput.value =
        activeInput.value.slice(0, start - 1) + activeInput.value.slice(end);
      activeInput.setSelectionRange(start - 1, start - 1);
    } else {
      activeInput.value =
        activeInput.value.slice(0, start) + activeInput.value.slice(end);
      activeInput.setSelectionRange(start, start);
    }
    activeInput.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function onKeyPress(button) {
    if (!activeInput) return;

    switch (button) {
      case '{bksp}':
        backspace();
        break;
      case '{enter}':
        osk.hidden = true;
        activeInput.blur();
        activeInput = null;
        break;
      case '{space}':
        insertAtCaret(' ');
        break;
      case '{tab}':
        insertAtCaret('\t');
        break;
      case '{caps}':
      case '{shift}':
        setLayout(layer === 'shift' ? 'default' : 'shift');
        break;
      case '{123}':
        setLayout('numbers');
        break;
      case '{abc}':
        setLayout('default');
        break;
      case '{lang}':
        toggleLang();
        break;
      default:
        insertAtCaret(button);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    enhanceExisting();
    initObserver();
  });
})();
